import fetch from "./fetch";
import axios from "./axios";

const baseUrl = process.env.REACT_APP_BASE_URL;
const apiBaseUrl = baseUrl + "/api";

export { fetch, axios, apiBaseUrl, baseUrl };
